import store from "../store/Index.js";
import { ensureRefresh, hasValidRefreshToken } from '../plugins/refreshManager.js';

export function installGuards(router) {
    router.beforeEach(async (to) => {

        const firstSegment = to.path.replace(/^\/+/, '').split('/')[0] || '';
        const publicRoutes = store.getters.getPublicRoutes;

        const isAuthenticated = store.getters.isAuthenticated;
        const hasRT = hasValidRefreshToken();

        // Public
        if (publicRoutes.includes(firstSegment)) {
            return isAuthenticated ? '/gestion' : true;
        }

        // Pas logué : pas de refresh token exploitable
        if (!hasRT) {
            return { path: '/connexion' };
        }

        // Tenter un seul refresh partagé
        try {
            if (!isAuthenticated) await ensureRefresh(store);

        } catch {
            // ne rien faire
        }

        if (!store.getters.isAuthenticated) {
            return { path: '/connexion' };
        } else {
            return true;
        }
    });
}